import { Box, Divider, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface SectionHeaderProps {
  title: string | ReactNode;
  description?: string;
  showDivider?: boolean;
}

/**
 * Generic section title with optional description and divider.
 */
export function SectionHeader({ title, description, showDivider = false }: SectionHeaderProps) {
  return (
    <Box sx={{ mt: 0, mb: 3 }}>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 500,
          color: 'text.primary',
        }}
      >
        {title}
      </Typography>

      {description && (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            mt: 0.5,
          }}
        >
          {description}
        </Typography>
      )}

      {showDivider && (
        <Divider
          sx={{
            mt: 2,
          }}
        />
      )}
    </Box>
  );
}
